import { useState } from "react";
import { useAuth } from "../../lib/auth";
import { Navigate, Link } from "react-router-dom";
import { LogOut, ExternalLink, FileText, Image as ImageIcon, MessageSquare, Quote, Settings, Layers, Eye, Search, FileEdit, Map, Tag, CalendarClock, CalendarCheck } from "lucide-react";
import ContentEditor from "./tabs/ContentEditor";
import ServicesManager from "./tabs/ServicesManager";
import TestimonialsManager from "./tabs/TestimonialsManager";
import GalleryManager from "./tabs/GalleryManager";
import MessagesInbox from "./tabs/MessagesInbox";
import SettingsTab from "./tabs/SettingsTab";
import VisibilityManager from "./tabs/VisibilityManager";
import PagesVisibilityManager from "./tabs/PagesVisibilityManager";
import BlogManager from "./tabs/BlogManager";
import SeoEditor from "./tabs/SeoEditor";
import PricingManager from "./tabs/PricingManager";
import AvailabilityManager from "./tabs/AvailabilityManager";
import BookingsManager from "./tabs/BookingsManager";

const TABS = [
  { id: "content", label: "Contenu pages", icon: FileText, component: ContentEditor },
  { id: "pages", label: "Pages publiques", icon: Map, component: PagesVisibilityManager },
  { id: "visibility", label: "Sections home", icon: Eye, component: VisibilityManager },
  { id: "services", label: "Services", icon: Layers, component: ServicesManager },
  { id: "pricing", label: "Tarifs", icon: Tag, component: PricingManager },
  { id: "availability", label: "Disponibilités", icon: CalendarClock, component: AvailabilityManager },
  { id: "bookings", label: "Réservations", icon: CalendarCheck, component: BookingsManager },
  { id: "gallery", label: "Galerie", icon: ImageIcon, component: GalleryManager },
  { id: "blog", label: "Blog", icon: FileEdit, component: BlogManager },
  { id: "testimonials", label: "Témoignages", icon: Quote, component: TestimonialsManager },
  { id: "seo", label: "SEO", icon: Search, component: SeoEditor },
  { id: "messages", label: "Messages", icon: MessageSquare, component: MessagesInbox },
  { id: "settings", label: "Réglages", icon: Settings, component: SettingsTab },
];

export default function AdminDashboard() {
  const { user, loading, logout } = useAuth();
  const [activeTab, setActiveTab] = useState("content");

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="loader" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const ActiveComponent = TABS.find((t) => t.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-[#F6F3EC] flex" data-testid="admin-dashboard">
      <aside className="w-64 bg-[#2D2A26] text-[#FDFBF7] min-h-screen flex flex-col fixed left-0 top-0 bottom-0">
        <div className="p-6 border-b border-[#FDFBF7]/10">
          <div className="font-serif text-xl">Sarita&apos;s</div>
          <div className="text-xs text-[#FDFBF7]/50 mt-1">Espace d&apos;administration</div>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <button key={t.id} onClick={() => setActiveTab(t.id)} className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition ${activeTab === t.id ? "bg-[#C87A5E] text-white" : "hover:bg-[#FDFBF7]/5 text-[#FDFBF7]/80"}`} data-testid={`admin-tab-${t.id}`}>
                <Icon size={16} /> {t.label}
              </button>
            );
          })}
        </nav>
        <div className="p-4 border-t border-[#FDFBF7]/10 space-y-1">
          <Link to="/" target="_blank" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-[#FDFBF7]/80 hover:bg-[#FDFBF7]/5">
            <ExternalLink size={14} /> Voir le site
          </Link>
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-[#FDFBF7]/80 hover:bg-[#FDFBF7]/5" data-testid="admin-logout">
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 p-10">
        {ActiveComponent && <ActiveComponent />}
      </main>
    </div>
  );
}
